import config from 'config';
import {
  getActiveOrganizationLink,
  getAllAssetsLink,
  getMasterOrganizationLink,
  getMuleSoftLink,
  getPresetLink,
  getSharedWithMeLink
} from './links';

export const addAllAssetsLink = ({
  links,
  query,
  isHomePage,
  isANGSearchEnabled
}) => {
  return [...links, getAllAssetsLink(query, isANGSearchEnabled, isHomePage)];
};

export const addMasterOrganizationLink = ({
  links,
  profile,
  query,
  isANGSearchEnabled,
  isANGSidebarConsistencyEnabled
}) => {
  const masterOrganization = profile.organization;
  const onlyOneBG = !masterOrganization.subOrganizationIds.length;

  if (onlyOneBG) return links;

  return [
    ...links,
    getMasterOrganizationLink(
      query,
      masterOrganization,
      isANGSearchEnabled,
      isANGSidebarConsistencyEnabled
    )
  ];
};

export const addActiveOrganizationLink = ({
  links,
  profile,
  query,
  isANGSearchEnabled
}) => {
  return [
    ...links,
    getActiveOrganizationLink(query, profile, isANGSearchEnabled)
  ];
};

export const addMulesoftLink = ({
  links,
  profile,
  query,
  isANGSearchEnabled,
  isANGSidebarConsistencyEnabled
}) => {
  return [
    ...links,
    getMuleSoftLink(
      query,
      profile,
      isANGSearchEnabled,
      isANGSidebarConsistencyEnabled
    )
  ];
};

export const addPresetLinks = ({
  links,
  query,
  presetLinkToEnabledMap,
  isANGSidebarConsistencyEnabled
}) => {
  const presetLinks = config.presetLinks.reduce(
    (accum, link) =>
      presetLinkToEnabledMap[link.id]
        ? [...accum, getPresetLink(query, link, isANGSidebarConsistencyEnabled)]
        : accum,
    []
  );

  return [...links, ...presetLinks];
};

export const addSharedWithMe = ({ links, query, isANGSearchEnabled }) => {
  return [...links, getSharedWithMeLink(query, isANGSearchEnabled)];
};
